import { get, patch } from "../../utils/request";

export const getProductsDetails = async (idProducts) => {
  const res = await get(`products?id=${idProducts}`);
  return res;
};

export const updateProduct = async (id, data) => {
  const res = await patch(`products/${id}`, data);
  return res.data;
};
